<template>
  <ul
    class='table-data'
    @mousedown="startDrag"
    @touchstart="startDrag"
  >
    <li
      :class="[
        'table-data-item',
        {'table-data-item--dragging': dragItemIndex === index},
      ]"
      v-for="(data, index) in items"
      :key="index"
      :style="{'transform': `translate3d(${removable && dragItemIndex === index ? -dragValue.x : 0}px, 0, 0)`}"
    >
      <slot
        name="item"
        :itemdata="data"
        :itemindex="index"
      >
        {{data.label || data.name}}
      </slot>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TableData',
  props: {
    items: { type: Array, default: null },
    removable: { type: Boolean, default: true },
  },
  data() {
    return {
      dragValue: { x: 0, y: 0 },
      dragItemIndex: -1,
    }
  },
  methods: {
    getItemIndex(target) {
      let selected = target
      while (selected.parentNode && selected.parentNode !== this.$el) {
        selected = selected.parentNode
      }
      return Array.prototype.indexOf.call(this.$el.childNodes, selected)
    },
    getDragFromEvent(e) {
      return {
        x: e.touches ? e.touches[0].clientX : e.clientX,
        y: e.touches ? e.touches[0].clientY : e.clientY,
      }
    },
    startDrag(e) {
      const index = this.getItemIndex(e.target)
      this.dragItemIndex = index
      this.dragOrigin = this.getDragFromEvent(e)
      switch (e.type) {
        case 'mousedown':
          window.addEventListener('mousemove', this.dragging)
          window.addEventListener('mouseup', this.stopDrag)
          break
        case 'touchstart':
          window.addEventListener('touchmove', this.dragging)
          window.addEventListener('touchend', this.stopDrag)
          break
      }
    },
    dragging(e) {
      this.dragValue = {
        x: Math.max(this.dragOrigin.x - this.getDragFromEvent(e).x, 0),
        y: this.dragOrigin.y - this.getDragFromEvent(e).y,
      }
    },
    stopDrag() {
      window.removeEventListener('mousemove', this.dragging)
      window.removeEventListener('mouseup', this.stopDrag)
      window.removeEventListener('touchmove', this.dragging)
      window.removeEventListener('touchend', this.stopDrag)
      if (this.dragItemIndex > -1) {
        if (this.dragValue.x < 25 && Math.abs(this.dragValue.y) < 25) {
          this.$emit('select', this.dragItemIndex)
        }
        if (this.dragValue.x > 100) {
          this.$emit('remove', this.dragItemIndex)
        }
      }
      this.dragValue = { x: 0, y: 0 },
      this.dragItemIndex = -1
    }
  },
}
</script>

<style lang="stylus">
  .table-data
    -webkit-overflow-scrolling touch
    overflow-x hidden
    overflow-y auto
    margin 0
    padding 0 1.0em
    list-style none
    user-select none
  .table-data-item
    transition transform 0.3s
  .table-data-item--dragging
    transition transform 0s
    opacity 0.5
</style>



// WEBPACK FOOTER //
// TableData.vue?4f07b753